<p-dialog
  [(visible)]="innerVisible"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '560px', maxWidth: '95vw', maxHeight: '90vh' }"
  [contentStyle]="{ overflow: 'auto' }"
  [header]="'onboarding.salesContact.title' | translate"
  (onHide)="onDismiss()">
  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4 p-2">
    <!-- Full name -->
    <div>
      <label for="sc-fullName" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.fullNameLabel' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        id="sc-fullName"
        type="text"
        formControlName="fullName"
        autocomplete="name"
        class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
      <div
        *ngIf="form.get('fullName')?.touched && form.get('fullName')?.errors?.['required']"
        class="mt-1 text-sm text-functional-error">
        {{
          'modules.scores.form.errors.required'
            | translate: { field: ('onboarding.salesContact.fullNameLabel' | translate) }
        }}
      </div>
      <div
        *ngIf="form.get('fullName')?.touched && form.get('fullName')?.errors?.['server']"
        class="mt-1 text-sm text-functional-error">
        {{ form.get('fullName')?.errors?.['server'] }}
      </div>
    </div>

    <!-- Billing department (MVP-40) -->
    <div>
      <label for="sc-department" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.departmentLabel' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        id="sc-department"
        type="text"
        formControlName="billingDepartment"
        autocomplete="organization"
        class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
      <div
        *ngIf="form.get('billingDepartment')?.touched && form.get('billingDepartment')?.errors?.['required']"
        class="mt-1 text-sm text-functional-error">
        {{
          'modules.scores.form.errors.required'
            | translate: { field: ('onboarding.salesContact.departmentLabel' | translate) }
        }}
      </div>
    </div>

    <!-- Billing street -->
    <div>
      <label for="sc-street" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.streetLabel' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        id="sc-street"
        type="text"
        formControlName="billingStreet"
        autocomplete="street-address"
        class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
      <div
        *ngIf="form.get('billingStreet')?.touched && form.get('billingStreet')?.errors?.['required']"
        class="mt-1 text-sm text-functional-error">
        {{
          'modules.scores.form.errors.required'
            | translate: { field: ('onboarding.salesContact.streetLabel' | translate) }
        }}
      </div>
    </div>

    <!-- Zip + city row -->
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label for="sc-zip" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
          {{ 'onboarding.salesContact.zipLabel' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          id="sc-zip"
          type="text"
          formControlName="billingZip"
          autocomplete="postal-code"
          class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
        <div
          *ngIf="form.get('billingZip')?.touched && form.get('billingZip')?.errors?.['required']"
          class="mt-1 text-sm text-functional-error">
          {{
            'modules.scores.form.errors.required'
              | translate: { field: ('onboarding.salesContact.zipLabel' | translate) }
          }}
        </div>
      </div>

      <div>
        <label for="sc-city" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
          {{ 'onboarding.salesContact.cityLabel' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          id="sc-city"
          type="text"
          formControlName="billingCity"
          autocomplete="address-level2"
          class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
        <div
          *ngIf="form.get('billingCity')?.touched && form.get('billingCity')?.errors?.['required']"
          class="mt-1 text-sm text-functional-error">
          {{
            'modules.scores.form.errors.required'
              | translate: { field: ('onboarding.salesContact.cityLabel' | translate) }
          }}
        </div>
      </div>
    </div>

    <!-- Country -->
    <div>
      <label for="sc-country" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.countryLabel' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-select
        id="sc-country"
        formControlName="billingCountryId"
        [options]="countries"
        optionLabel="name"
        optionValue="id"
        appendTo="body"
        [placeholder]="'modules.onboarding.registration.profile_info.country.placeholder' | translate"
        [styleClass]="'w-full p-2 bg-neutral-gray20 rounded'">
      </p-select>
      <div
        *ngIf="form.get('billingCountryId')?.touched && form.get('billingCountryId')?.errors?.['required']"
        class="mt-1 text-sm text-functional-error">
        {{
          'modules.scores.form.errors.required'
            | translate: { field: ('onboarding.salesContact.countryLabel' | translate) }
        }}
      </div>
    </div>

    <!-- Invoicing email -->
    <div>
      <label for="sc-email" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.invoicingEmailLabel' | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        id="sc-email"
        type="email"
        formControlName="invoicingEmail"
        autocomplete="email"
        class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none" />
      <div
        *ngIf="form.get('invoicingEmail')?.touched && form.get('invoicingEmail')?.errors?.['required']"
        class="mt-1 text-sm text-functional-error">
        {{
          'modules.scores.form.errors.required'
            | translate: { field: ('onboarding.salesContact.invoicingEmailLabel' | translate) }
        }}
      </div>
      <div
        *ngIf="form.get('invoicingEmail')?.touched && form.get('invoicingEmail')?.errors?.['invalidEmail']"
        class="mt-1 text-sm text-functional-error">
        {{ 'modules.scores.form.errors.email_invalid' | translate }}
      </div>
    </div>

    <!-- Message -->
    <div>
      <label for="sc-message" class="mb-2 block text-sm font-medium leading-5 text-neutral-gray70">
        {{ 'onboarding.salesContact.messageLabel' | translate }}
      </label>
      <textarea
        id="sc-message"
        formControlName="message"
        rows="4"
        [placeholder]="'onboarding.salesContact.messagePlaceholder' | translate"
        class="focus:border-primary w-full rounded-lg border border-neutral-gray30 px-3 py-2 focus:outline-none"></textarea>
    </div>

    <div
      *ngIf="serverError"
      class="bg-functional-errorBg rounded-md border border-functional-error p-2 text-sm text-functional-error">
      {{ serverError }}
    </div>

    <div class="mt-2 flex items-center justify-end gap-3">
      <button
        type="button"
        (click)="innerVisible = false"
        [disabled]="isSubmitting"
        class="rounded-lg border border-neutral-gray30 px-4 py-3 text-sm font-medium text-neutral-gray70 transition hover:bg-neutral-gray20 disabled:cursor-not-allowed disabled:opacity-50">
        {{ 'onboarding.salesContact.cancel' | translate }}
      </button>
      <button
        type="submit"
        [disabled]="form.invalid || isSubmitting"
        class="flex items-center rounded-lg bg-primary-90 p-3 text-sm font-medium text-neutral-white focus:outline-none disabled:cursor-not-allowed disabled:bg-primary-10 disabled:opacity-50">
        <span *ngIf="isSubmitting" class="spinner mr-2"></span>
        {{ 'onboarding.salesContact.submit' | translate }}
      </button>
    </div>
  </form>
</p-dialog>
